import React, { useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { colors } from 'app-constants';
import { useClickOutside } from 'hooks';
import { SketchPicker } from 'react-color';
import Checkboard from 'react-color/lib/components/common/Checkboard';


const ColorPicker = ({
  name,
  value,
  clearable = true,
  onChange = () => {},
}) => {
  const [showPicker, setShowPicker] = useState(false);
  const togglePicker = () => setShowPicker(os => !os);

  const handleClick = togglePicker;
  const handleFocus = () => setShowPicker(true);
  const handlePickerChange = color => onChange(color.hex);
  const handleClearClick = () => onChange('');

  const containerRef = useRef();
  const handleClickOutside = useCallback(() => setShowPicker(false), [setShowPicker]);
  useClickOutside(containerRef, handleClickOutside);

  const buttonStyle = { cursor: 'pointer' };
  if (showPicker) {
    buttonStyle.backgroundColor = colors.blueExtraLight;
  }

  const clearButtonStyle = {
    backgroundColor: '#E2E2E2',
    borderRadius: '50%',
    color: '#8a8a8a',
    cursor: 'pointer',
    fontSize: '18px',
    height: 18,
    lineHeight: '18px',
    position: 'absolute',
    right: 5,
    textAlign: 'center',
    top: '50%',
    transform: 'translateY(-50%)',
    width: 18,
  };

  const pickerWrapStyle = {
    backgroundColor: '#fff',
    borderRadius: 4,
    display: showPicker ? 'block' : 'none',
    left: 0,
    marginBottom: 20,
    padding: 1,
    position: 'absolute',
    top: '120%',
    zIndex: 999,
  };

  return (
    <div style={{ position: 'relative', width: 150 }} ref={containerRef}>
      <div className="input-group">
        <span className="input-group-addon" style={buttonStyle} onClick={handleClick}>
          <div style={{ backgroundColor: value, border: '1px solid #fff', width: 24, height: 24, position: 'relative' }}>
            {!value ? <Checkboard white="#fff" gray="#999" size={6} /> : null}
          </div>
        </span>
        <input
          type="text"
          className="form-input"
          name={name}
          value={value ? value.toUpperCase() : ''}
          onFocus={handleFocus}
          readOnly
          style={{ backgroundColor: '#fff' }} // Override read-only style
        />
        {clearable && !!value && <div style={clearButtonStyle} onClick={handleClearClick}>&times;</div>}
      </div>
      <div style={pickerWrapStyle}>
        <SketchPicker disableAlpha onChangeComplete={handlePickerChange} color={value || {}} />
      </div>
    </div>
  );
};

ColorPicker.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  clearable: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ColorPicker;
